import React from 'react'
import PropTypes from 'prop-types'
import { useEffect } from 'sb-hooks'
import { constants, sentry } from 'common/helpers'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'


const ServerErrorModal = composeDialogModal({
  name: constants.modals.ServerError,
  title: ({ data }) => (data.title || messages.title),
  content: ({ data }) => data.content,
  buttonTitle: ({ data }) => data.buttonTitle,
  propTypes: {
    data: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
      buttonTitle: PropTypes.string,
    }),
  },
})


const ServerErrorModalWrapper = (props) => {
  const { data } = props

  useEffect(() => {
    const { statusCode, body } = data

    const isTerminated = statusCode === undefined && body === undefined

    if (!isTerminated && statusCode !== 502) {
      const title = `Server error${statusCode >= 500 ? ` ${statusCode}` : ''}`

      sentry.captureMessage(title, {
        extra: data,
      })
    }
  }, [ data ])

  return (
    <ServerErrorModal {...props} />
  )
}


export default ServerErrorModalWrapper
